import { Contractor } from "@/api/williams/contractors";
import { Project } from "@/api/williams/project";
import { TestEvent, TestEventStatus } from "@/api/williams/testEvents";
import { TestEventForm } from "./form";
import { useDefaultEvent } from "./hooks";
import { useLocation } from "react-router-dom";
import { useQualifierUserList } from "@/queries/user.queries";
import { v4 as uuid } from "uuid";
import { Welder } from "@/api/williams/welders";

export type LocationState = {
  state: {
    project?: Project;
    contractor?: Contractor;
    welders?: Welder[];
  };
};

export function CreateTestEvent() {
  const defaults = useDefaultEvent();
  const location = useLocation();
  const users = useQualifierUserList();

  const { state } = location as LocationState;

  if (defaults.isLoading || users.isLoading) {
    return <p>Loading...</p>;
  }

  const defaultValues: TestEvent = {
    id: uuid(),
    number: defaults.data?.number ?? "",
    description: "",
    owner: defaults.data?.owner,
    status: TestEventStatus.New,
    locked: false,
    project: state?.project,
    welders: state?.welders ?? [],
    tests: [],
    welderTests: [],
    contractorId: state?.contractor?.id,
  };

  return <TestEventForm data={defaultValues} />;
}
